import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export type PageWidth = 'narrow' | 'default' | 'wide' | 'full';

const WIDTHS: Record<PageWidth, string> = {
  narrow: 'max-w-2xl',
  default: 'max-w-5xl',
  wide: 'max-w-7xl',
  full: 'max-w-none',
};

export interface PageProps extends HTMLAttributes<HTMLDivElement> {
  width?: PageWidth;
}

/** Page container: one of four named widths instead of ad-hoc max-w-* per page. */
export const Page = forwardRef<HTMLDivElement, PageProps>(function Page({ width = 'default', className, children, ...rest }, ref) {
  return (
    <div ref={ref} className={cn('mx-auto w-full', WIDTHS[width], className)} {...rest}>
      {children}
    </div>
  );
});
